document.addEventListener('DOMContentLoaded', function () {
    const swipers = document.querySelectorAll('.celle-swiper');

    swipers.forEach(function (swiperEl) {
        const swiper = new Swiper(swiperEl, {
            loop: true,
            effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets',
            },
            autoplay: {
                delay: 8000,
                disableOnInteraction: false,
            },
            speed: 800,
        });

        // Pause bei Hover
        swiperEl.addEventListener('mouseenter', function () {
            swiper.autoplay.pause();
        });

        swiperEl.addEventListener('mouseleave', function () {
            swiper.autoplay.resume();
        });

        // Pause/Play Button Funktionalität
        const pauseBtn = swiperEl.closest('.celle-content-slider').querySelector('.slider-pause-btn');
        const pauseIcon = pauseBtn.querySelector('.pause-icon');
        const playIcon = pauseBtn.querySelector('.play-icon');
        const btnText = pauseBtn.querySelector('.btn-text');

        pauseBtn.addEventListener('click', function () {
            if (swiper.autoplay.running) {
                swiper.autoplay.stop();
                pauseIcon.style.display = 'none';
                playIcon.style.display = 'inline';
                pauseBtn.setAttribute('aria-label', 'Slider fortsetzen');
                btnText.textContent = 'Slider fortsetzen';
            } else {
                swiper.autoplay.start();
                pauseIcon.style.display = 'inline';
                playIcon.style.display = 'none';
                pauseBtn.setAttribute('aria-label', 'Slider pausieren');
                btnText.textContent = 'Slider pausieren';
            }
        });
    });
});